/**
 * Created by PhpStorm
 * Author: Mikhail Zheludkov <mzheludkov@clubautomation.com>
 * Date: 07/27/2016
 * Time: 10:00 AM
 */

/**
 * "Select2" is a mobile-friendly control unlike "Chosen"
 */
(function($) {
    $(function() {
        $.widget('ca.caSelectPro', {
            options: {
                width: '100%',
                placeholder: 'Select an option',
                searchInputPlaceholder: 'Search',
                withInput: false,
                inputValue: '',
                inputPlaceholder: 'Type a value...',
                onChange: function () {},
            },

            _create: function() {
                var self = this;
                var options = this.options;
                var select = this.element;
                var width = options.width;
                $(select).select2(options);

                $(select).on('change', function(e) {
                    self.options.onChange(e.target.value);
                    var dependantElement = $('#' + $(e.target).data('dependent'));
                    if (dependantElement.length) {
                        var allMultioptions = dependantElement.data('dependent-multioptions');
                        if (e.target.value in allMultioptions) {
                            dependantElement.caSelectPro('replaceOptions', allMultioptions[e.target.value]);
                        }
                    }
                });

                $(select).on('select2-open', function() {
                    var li = $('body > .select2-drop-multi').find('ul.select2-results').find('li:not(.select2-selected)').first();
                    li.addClass('select2-highlighted');
                });
                $('#s2id_' + $(select).prop('id')).on('keyup', function() {
                    var highlighted = $('body > .select2-drop-multi').find('ul.select2-results').find('li.select2-highlighted');
                    if (!highlighted.length) {
                        var li = $('body > .select2-drop-multi').find('ul.select2-results').find('li:not(".select2-selected")').first();
                        li.addClass('select2-highlighted');
                    }
                });

                var formGroup = select.parents('.form-group');
                if (!width) {
                    if (formGroup.length) {
                        width = '100%';
                    } else {
                        width = select.outerWidth();
                    }
                    if (!width) {
                        width = select.css('width');
                    }
                }

                width = String(width);
                if (width.indexOf('px') == -1 && width.indexOf('%') == -1) {
                    width += 'px';
                }

                select.width(width);

                if (options.withInput) {
                    this.initInputField(width);
                }
            },

            refresh: function() {
                this.element.select2(this.options);
            },

            initInputField: function (width) {
                var options = this.options;
                var select = this.element;
                var wrapper = this.element.parent();
                var inputId = this.element.prop('id') + '-input';
                var $inputField = $('<input>')
                    .prop('id', inputId)
                    .prop('name', inputId)
                    .prop('type', 'text')
                    .prop('value', options.inputValue)
                    .prop('placeholder', options.inputPlaceholder)
                    .prop('class', 'ca-text-field form-control');
                wrapper.append('<br/>')
                    .append($inputField);
                $inputField.width(width);
                $(select).on('change', function(){
                    if ($(this).val() == '') {
                        $('#' + inputId).show();
                    } else {
                        $('#' + inputId).hide();
                    }
                }).trigger("change");
            },

            generateOptions: function(data) {
                if (typeof data === 'undefined') {
                    return '<option value="">-</option>';
                }
                var dataKeys = Object.keys(data);
                var option = '';
                for (var i=0; i < dataKeys.length; i++) {
                    var value = dataKeys[i];
                    var label = data[value];
                    option += '<option value="' + value + '">' + label + '</option>';
                }

                return option;
            },

            replaceOptions: function (data) {
                var options = this.generateOptions(data);
                this.element.html(options);
                this.refresh();
            }
        });
    });
})(jQuery);